export const UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE'
export const SET_DID_SET_INTERVAL_RUN = 'SET_DID_SET_INTERVAL_RUN'
export const UPDATE_PORTAL = 'UPDATE_PORTAL'
